import React, { useEffect, useState } from "react";
import s from "./get-demo.module.scss";
import { InputText, TextArea } from "commons/input-controls";
import EchoButton from "pages/landing-page/items/echo-button/echo-button";
import Input from 'react-phone-number-input/input'

const GetDemo = (props) => {

    const [name, setName] = useState(null);
    const [nameError, setNameError] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [email, setEmail] = useState(props.email ? props.email : null);
    const [phoneNumberError, setPhoneNumberError] = useState(false);
    const [keyword, setKeyword] = useState(null);
    const [isGetDemoSuccess, setIsGetDemoSuccess] = useState(props.isDemoSuccess);
    const [isEmailValid, setIsEmailValid] = useState(null);

    useEffect(() => {
        setIsGetDemoSuccess(props.isDemoSuccess);
    }, [props.isDemoSuccess]);

    const phoneRegExp = /^(\+?\d{11})$/;
    const emailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    const SetUserName = (name) => {
        setName(name);
    }

    const SetPhone = (phone) => {
        setPhoneNumber(phone);
    }

    const setTopicKeywords = (keyword) => {
        setKeyword(keyword)
    }

    const checkPhoneNumber = (phoneNumber) => {
        if(phoneNumber && phoneNumber.match(phoneRegExp)){
            return true;
        }
        else{
            return false;
        }
    }

    const inputChangeEmail = (email) => {
        setEmail(email);
    }
    
    const checkEmail = (email) => {
        if(!email || email && email.match(emailRegExp)){
            return true
        }
        else{
            return false
        }
    }

    const getDemo = () => {
        if(!name){ 
            setNameError(props.getValue('FIELD_NOT_BE_EMPTY'));
        }
        else if(!checkPhoneNumber(phoneNumber)){
            setPhoneNumberError(props.getValue('ONLY_NUMBER'));
        }
        else if(!checkEmail(email)){
            setIsEmailValid(props.getValue("NOT_VALID_EMAIL"));
        }
        else{
            props.sendMessage(name, phoneNumber, 'DEMO', keyword, null, email);
        }
    }

    const close = () => {
        props.setIsDemoSuccess(false);
        props.modalShowToggle(false);
        props.callback(false);
    }

    const content = !isGetDemoSuccess 
                    ? <React.Fragment>
                        <div className="formRow">
                            <InputText value={name} labelText={props.getValue('NAME')} notEmpty={true} callback={SetUserName} error={nameError} placeholder={props.getValue("NAME")}/>
                        </div>
                        <div className="formRow">
                            <InputText value={email} labelText={props.getValue('EMAIL')} hideRedStar={true} callback={inputChangeEmail} error={nameError} placeholder={props.getValue("EMAIL_ADDRESS")}/>
                        </div>
                        <div className="formRow">
                            <span className="labelText">{props.getValue('PHONE')}<span className={s.redStar}>*</span></span>
                            <div className={s.inputBlock}>
                                <Input
                                    country="KZ"
                                    international
                                    withCountryCallingCode
                                    value={phoneNumber}
                                    placeholder={props.getValue('TELEPHONE')}
                                    onChange={SetPhone}
                                />
                            </div>
                            {/*<InputText value={phoneNumber} labelText={props.getValue('PHONE')} notEmpty={true} callback={SetPhone} error={phoneNumberError} placeholder={props.getValue("PHONE")+" "+"XXXXXXXXXXX"}/> */}
                        </div>
                        <div className={"formRow"}>
                            <span className="labelText">{props.getValue('TOPICS_FOR_MONITORING')}</span>
                            <TextArea height={14} rows={9} callback={setTopicKeywords}/>
                        </div>
                        <div className={s.demoLicenseAgreement}>
                            <span>{props.getValue('GET_DEMO_LICENSE')}</span>
                            <a><span>{props.getValue('GET_DEMO_LICENSE_POLICY')}</span></a>
                            <span>{props.getValue('GET_DEMO_LICENSE_2')}</span>
                        </div>
                    </React.Fragment>
                    : <div className="formRow">
                        <span>{ props.getValue('GET_DEMO_SUCCESS')}</span>
                    </div>

    return (
        <div className={s.GetDemo}>
            { content }
            <div>
                {!isGetDemoSuccess ? <EchoButton disabled={!checkPhoneNumber(phoneNumber) || name == null || name == "" || !checkEmail(email)} styles={{width: '100%'}} title={props.getValue('GET_DEMO_ACCESS')} callback={getDemo}/>
                : <EchoButton styles={{width: '100%'}} title={props.getValue('CLOSE')} callback={close}/>}
            </div>
        </div>
    )
}

export default GetDemo;